import { ListPartnerContactsResponseSchema } from './list-partner-contacts.schema';
export const listPartnerContactsContract = {
    method: 'GET',
    path: '/api/v2/partner/contacts',
    description: "List the caller's own partner call list",
    responseSchema: ListPartnerContactsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member'
        }
    }
};

//# sourceMappingURL=list-partner-contacts.contract.js.map